var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMusculoesqueletico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.822,
    height: 47.825,
    viewBox: "0 0 47.822 47.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13740.914 11163.805)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18610.629 -11787.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4973.492,863.01a1.727,1.727,0,0,1-1.018-1.844c.046-1.278,0-2.56.018-3.84a.458.458,0,0,0-.331-.5,8.2,8.2,0,1,1,6.6-15.008,1.128,1.128,0,0,0,1.168,0,8.2,8.2,0,1,1,6.6,15.009.458.458,0,0,0-.331.5c.014,1.28-.028,2.561.018,3.84a1.727,1.727,0,0,1-1.018,1.844Zm8.185-18.964c.1.15.17.264.247.373a8.192,8.192,0,0,1,1.528,4.519,1.384,1.384,0,1,1-2.739.112,5.486,5.486,0,1,0-7.1,5.371c1.422.418,1.616.676,1.616,2.159v3.659h8.231v-.478c0-1.2,0-2.408,0-3.612a1.43,1.43,0,0,1,1.154-1.584c.145-.048.29-.1.436-.136a5.185,5.185,0,0,0,2.656-1.773,5.457,5.457,0,0,0-6.03-8.609Z",
    transform: "translate(-85.72 -192.052)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5225.964,818.567a1.721,1.721,0,0,1-1.84,1.018c-1.185-.046-2.373-.009-3.56-.013a1.381,1.381,0,1,1,0-2.742c1.187,0,2.375.034,3.56-.013a1.721,1.721,0,0,1,1.84,1.018Z",
    transform: "translate(-308.927 -170.655)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4979.487,624.133q2.606,0,5.211,0a1.411,1.411,0,0,1,1.606,1.593c0,1.341.011,2.682-.007,4.022a.538.538,0,0,0,.4.6,8.215,8.215,0,0,1-1.754,15.7,7.82,7.82,0,0,1-5.05-.788.863.863,0,0,0-.881-.006,8.192,8.192,0,0,1-11.87-7.871,7.95,7.95,0,0,1,5.008-7.016.6.6,0,0,0,.449-.657c-.026-1.34-.013-2.681-.009-4.022a1.4,1.4,0,0,1,1.551-1.556C4975.922,624.13,4977.705,624.133,4979.487,624.133Zm-2.383,18.945c-.091-.135-.156-.237-.227-.335a8.111,8.111,0,0,1-1.542-4.651,1.375,1.375,0,1,1,2.74-.068,5.45,5.45,0,0,0,6.451,5.3,5.157,5.157,0,0,0,4.229-3.668,5.259,5.259,0,0,0-1.162-5.4,5.37,5.37,0,0,0-2.7-1.626,1.5,1.5,0,0,1-1.336-1.767q0-1.372,0-2.743v-1.209h-8.231v3.828c0,1.239-.247,1.569-1.437,1.923a5.453,5.453,0,1,0,3.209,10.415Z",
    transform: "translate(-85.821 0)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4873.661,819.648c-.67,0-1.341.008-2.011,0a1.371,1.371,0,1,1,.006-2.738q2.035-.016,4.069,0a1.371,1.371,0,1,1-.006,2.738C4875.033,819.656,4874.347,819.648,4873.661,819.648Z",
    transform: "translate(0 -170.731)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4900.375,748.817a1.449,1.449,0,0,1-.79,1.349,1.189,1.189,0,0,1-1.411-.147c-1.027-.974-2.035-1.971-3-3a1.348,1.348,0,0,1,1.889-1.9c1.033.967,2.025,1.979,3,3A2.009,2.009,0,0,1,4900.375,748.817Z",
    transform: "translate(-21.828 -106.883)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5212.482,746.46a3.473,3.473,0,0,1-.473.813c-.857.907-1.748,1.784-2.642,2.656a1.368,1.368,0,1,1-1.934-1.932q1.325-1.357,2.682-2.681a1.3,1.3,0,0,1,1.554-.285A1.47,1.47,0,0,1,5212.482,746.46Z",
    transform: "translate(-298.266 -106.951)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4896.354,870.307a1.438,1.438,0,0,1-1.341-.774,1.181,1.181,0,0,1,.132-1.411c.984-1.038,1.991-2.057,3.037-3.032a1.346,1.346,0,0,1,1.877,1.893c-.978,1.043-2,2.044-3.036,3.033A1.876,1.876,0,0,1,4896.354,870.307Z",
    transform: "translate(-21.811 -213.148)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5210.925,870.437a3.086,3.086,0,0,1-.8-.438c-.929-.878-1.83-1.788-2.721-2.706a1.367,1.367,0,1,1,1.947-1.916c.906.882,1.8,1.779,2.682,2.681a1.308,1.308,0,0,1,.3,1.553A1.471,1.471,0,0,1,5210.925,870.437Z",
    transform: "translate(-298.256 -213.27)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMusculoesqueletico);
export default __webpack_public_path__ + "static/media/ICO-MUSCULOESQUELETICO.4c066a71e275241ea0cae8819be82ce7.svg";
export { ForwardRef as ReactComponent };